import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicePage = lazy(() => import('../pages/service/page'));
const MarketingPage = lazy(() => import('../pages/service/marketing/page'));
const EcommercePage = lazy(() => import('../pages/service/ecommerce/page'));
const SalesPage = lazy(() => import('../pages/service/sales/page'));
const OthersPage = lazy(() => import('../pages/service/others/page'));
const CasePage = lazy(() => import('../pages/case/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/service',
    element: <ServicePage />
  },
  {
    path: '/service/marketing',
    element: <MarketingPage />
  },
  {
    path: '/service/e-commerce',
    element: <EcommercePage />
  },
  {
    path: '/service/sales',
    element: <SalesPage />
  },
  {
    path: '/service/others',
    element: <OthersPage />
  },
  {
    path: '/case',
    element: <CasePage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
